import script from "./TextWriteRender.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextWriteRender.vue?vue&type=script&setup=true&lang=ts"

import "./TextWriteRender.vue?vue&type=style&index=0&id=4b131c5e&scoped=true&lang=scss"

import exportComponent from "/home/orynik/Documents/source/personal/trainer-blind-print/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b131c5e"]])

export default __exports__